import React, {useContext, useRef, useState} from "react";
import {
    ButtonV2,
    CheckboxV2,
    Typography,
} from "@/elements";
import TableScroll from "../../components/global/table/TableScroll";
import TablePaginationComponent from "../../components/global/table/TablePagination";
import {PageContext} from "../../context/pages";
import {useLazyQuery} from "@apollo/client";
import {useDebouncedEffect} from "../../hooks/useDebouncedEffect";
import {useParams} from "react-router";
import TableDnsZones from "./TableDnsZones";
import {GET_DNS_ZONES} from "../../actions/get";
import {AntContainer} from "../../theme/Wrapper";
import {FormControlLabel, Grid, TableContainer} from "@mui/material";

const DnsZones = () => {
    const table = useRef(null);
    const { filter, setFilter } = useContext(PageContext);
    const [sortActive, setSortActive] = useState('sortL7ResourceId');
    const [isDelegated, setIsDelegated] = useState('');
    const [zoneType, setZoneType] = useState('');


    const { id: partnerClientAccountId } = useParams();

    const [getFilter, { data, loading }] = useLazyQuery(GET_DNS_ZONES);
    const getVariables = () => {
        const proxy = {
            limit: filter.limit,
            page: filter.page + 1,
            [sortActive]: filter?.sort?.[sortActive]?.toUpperCase() || 'DESC',
        };

        if (filter?.id) {
            proxy.id = Number(filter?.id);
        }

        if (filter?.zone) {
            proxy.zone = String(filter?.zone)
        }

        if (isDelegated) {
            proxy.delegated = isDelegated
        }

        !filter?.sort?.checked ? proxy.deletedAtEq = null : proxy.deletedAtNeq = null

        if(zoneType) {
            zoneType === 'primary' ? proxy.remoteIdNeq = null : proxy.remoteIdEq = null
        }

        return proxy;
    };

    useDebouncedEffect(
        () => {
            getFilter({ variables: getVariables() });
        },
        500,
        [filter, isDelegated, zoneType],
    );
    return (
        <AntContainer maxWidth={false}>
            <TableScroll tableRef={table}>
                <TableContainer>
                    <Grid container>
                        <Grid item xs>
                            <Typography variant="h6">Zones </Typography>
                        </Grid>
                        <Grid item xs={12} sm="auto">
                            <FormControlLabel
                                style={{ marginRight: 40 }}
                                control={
                                    <CheckboxV2
                                        checked={filter?.sort?.checked || false}
                                        onChange={event =>
                                            setFilter({
                                                ...filter,
                                                sort: { ...filter?.sort, checked: event.target.checked },
                                            })
                                        }
                                        name="checkedA"
                                        color="primary"
                                    />
                                }
                                label="Show deleted accounts"
                            />
                        </Grid>
                    </Grid>
                    <TableDnsZones
                        data={data}
                        setFilter={setFilter}
                        filter={filter}
                        sortActive={sortActive}
                        setSortActive={setSortActive}
                        partnerClientAccountId={partnerClientAccountId}
                        isDelegated={isDelegated}
                        setIsDelegated={setIsDelegated}
                        zoneType={zoneType}
                        setZoneType={setZoneType}
                    />
                    <TablePaginationComponent
                        filter={filter}
                        setFilter={setFilter}
                        count={data && data?.dnsResources?.info?.totalCount}
                        getFilter={getFilter}
                        getVariables={getVariables()}
                        type={'FILTER_ACTIVE'}
                    />
                </TableContainer>
            </TableScroll>

        </AntContainer>
    )
};
export default DnsZones;
